export const CHECKOUT_BREAK_POINT = 872;
export const QUICK_CHECKOUT_BREAK_POINT = 542;

export const IFRAME_WIDTH = '983px';
